import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuard} from './core/guards/auth.guard';
import {UnAuthGuard} from './core/guards/un-auth.guard';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/system/system.module').then(m => m.SystemModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
    canActivate: [UnAuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes /*, { useHash: true }*/, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
